<form [formGroup]="weekForm">

    <fieldset [disabled]="isSubmitting">

        <div class="line mb-4">
            <button mat-raised-button color="default" (click)="copyPreviousWeekValues()">{{ 'CopyPreviousWeekValues' | translate }}</button>
        </div>

        <div class="line line-margin">
          <div class="pseudo-form-field no-mat-form-field-underline">
            <mat-label class="required">{{ 'Physical' | translate }}</mat-label>
            <mat-slider thumbLabel min="0" max="100" step="5" tickInterval="5" showTickMarks discrete [displayWith]="formatLabel">
              <input matSliderThumb formControlName="physicalPercent" (change)="onSliderChange($event, 'physicalPercent')">
            </mat-slider>
            <mat-error *ngIf="f['physicalPercent'].errors && f['physicalPercent'].errors?.['required']">{{ 'Field_required' | translate }}</mat-error>
          </div>
        </div>

        <div class="line line-margin">
          <div class="pseudo-form-field no-mat-form-field-underline">
            <mat-label class="required">{{ 'Sport' | translate }}</mat-label>
            <mat-slider thumbLabel min="0" max="100" step="5" tickInterval="5" showTickMarks discrete [displayWith]="formatLabel">
              <input matSliderThumb formControlName="sportPercent" (change)="onSliderChange($event, 'sportPercent')">
            </mat-slider>
            <mat-error *ngIf="f['sportPercent'].errors && f['sportPercent'].errors?.['required']">{{ 'Field_required' | translate }}</mat-error>
          </div>
        </div>

        <div class="line line-margin">
            <div class="pseudo-form-field no-mat-form-field-underline">
                <mat-label class="required">{{ 'Intensity' | translate }}</mat-label>
              <mat-slider thumbLabel min="0" max="100" step="5" tickInterval="5" showTickMarks discrete [displayWith]="formatLabel">
                <input matSliderThumb formControlName="intensityPercent" (change)="onSliderChange($event, 'intensityPercent')">
              </mat-slider>
              <mat-error *ngIf="f['intensityPercent'].errors && f['intensityPercent'].errors?.['required']">{{ 'Field_required' | translate }}</mat-error>
            </div>
        </div>

        <div class="line">
            <mat-form-field color="primary">
                <mat-select placeholder="{{ 'Accents' | translate }}" [compareWith]="compareObjects" formControlName="exerciseCategories" multiple>
                    <mat-option *ngFor="let category of exerciseCategories" [value]="category">
                        <span class="category-color" [style.background-color]="category.colorHex"></span>&nbsp;{{ category.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="line line-margin">
            <mat-form-field>
                <mat-label>{{ 'Event_Comment' | translate }}</mat-label>
                <textarea class="default"
                          matInput
                          cdkTextareaAutosize
                          formControlName="comment"
                          maxlength="{{ DESCRIPTION_MAX_LENGTH }}"
                          #commentInput></textarea>
                <mat-hint align="end">{{ commentInput.value.length }} / {{ DESCRIPTION_MAX_LENGTH }}</mat-hint>
                <mat-error *ngIf="f['comment'].errors">{{ 'Field_Max_length' | translate: {max: 250} }}</mat-error>
            </mat-form-field>
        </div>
    </fieldset>
</form>
